import React from 'react';
import { useLocation } from 'react-router-dom';
import { useI18n } from 'utils/I18n/context';

export default function AuthorisationErrorPage() {
    const { t } = useI18n();
    const location = useLocation();

    const title =
        t?.errorPage?.authorisationError?.title ?? 'Authorization error';
    const message = location.state?.message ?? '';

    return (
        <div className="notfound text-center">
            <h1>401</h1>
            <h3 className="font-bold">{title}</h3>
            <div className="error-desc">{message}</div>
        </div>
    );
}
